import { db } from "../Firebase";
import { collection, getDocs, query, where } from "firebase/firestore";

/**
 * ตรวจสอบการเข้าสู่ระบบกับ Firestore
 * @param {string} username 
 * @param {string} password 
 * @returns {Promise<{success: boolean, data?: object, error?: string}>}
 */
export const verifyLogin = async (username, password) => {
  try {
    const q = query(collection(db, "P3"), where("username", "==", username.trim().toLowerCase()));
    const querySnapshot = await getDocs(q);
    
    let loginSuccessful = false;
    let userDataFound = null;

    querySnapshot.forEach((doc) => {
      const userData = doc.data();
      
      const normalizedPassword = password.trim().toLowerCase();
      const dbPassword = (typeof userData.password === 'string' ? userData.password.trim().toLowerCase() : 
                         typeof userData.password === 'number' ? userData.password.toString().toLowerCase() : '') || '';
      
      if (normalizedPassword === dbPassword) {
        loginSuccessful = true;
        userDataFound = {
          ...userData, 
          username: userData.username,
          level: userData.level || 0,
          score: userData.score || 0,
          collection: "P3",
          id: doc.id
        };
      }
    });

    if (loginSuccessful && userDataFound) {
      return { success: true, data: userDataFound };
    } else {
      return { success: false, error: "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง" };
    }
  } catch (error) {
    console.error("Login Error:", error);
    return { success: false, error: "เกิดข้อผิดพลาดในการเชื่อมต่อ" };
  }
};
